import { Button } from "@/src/components/ui/button";
import { BookingCard } from "@/src/components/wrappers/BookingCard";
import { ExternalLink } from "lucide-react";
import { Booking } from "../../model";
import { useState } from "react";
import { EditBookingStatusModal } from "../../EditBookingStatus";

const ExternalBookingDetailsSection = ({ booking }: { booking: Booking }) => {
  const [updateStatusOpen, setUpdateStatusOpen] = useState(false);

  return (
    <div className="flex w-full gap-6">
      <BookingCard className="flex flex-col grow w-[356px] gap-6 relative justify-between">
        <div className="flex items-center gap-6">
          <span className="text-base font-medium">Status</span>
          <span className="flex bg-blue-50 w-max rounded-[25px] py-1.5 px-3 leading-4">
            {booking.hubspotStatus[0].toUpperCase()}
            {booking.hubspotStatus.split("_").join(" ").substring(1)}
          </span>
        </div>
        <div className="flex items-center gap-6">
          <span className="text-base font-medium">Brand</span>
          <span
            className={`flex w-max rounded-[25px] py-1.5 px-3 leading-4 capitalize ${booking?.brand === "helm" ? "bg-[#0000dc] text-white" : "bg-[#e9695e] text-white"}`}
          >
            {booking.brand}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <Button
            onClick={() => {
              setUpdateStatusOpen(true);
            }}
            variant="link"
          >
            Edit
          </Button>{" "}
        </div>
      </BookingCard>
      {updateStatusOpen && (
        <EditBookingStatusModal
          open={updateStatusOpen}
          setOpen={setUpdateStatusOpen}
          initialStatus={booking?.hubspotStatus}
          bookingId={booking?.id}
          brand={booking?.brand}
        />
      )}
      <BookingCard className="flex grow w-[356px] gap-6 items-center justify-between">
        <Button className="text-black p-0 text-base font-medium" variant="link">
          Booking Sheet
          <ExternalLink className="ml-1.5" size={20} />
        </Button>
      </BookingCard>
      <BookingCard className="flex grow w-[356px] gap-6 items-center justify-between">
        <Button className="text-black p-0 text-base font-medium" variant="link">
          Our Bookings <ExternalLink className="ml-1.5" size={20} />
        </Button>
      </BookingCard>
    </div>
  );
};

export default ExternalBookingDetailsSection;
